// extracted by mini-css-extract-plugin
export var bottom = "AgreementNewTermsReasonView-module--bottom--b998f";
export var container = "AgreementNewTermsReasonView-module--container--3d7c5";
export var content = "AgreementNewTermsReasonView-module--content--abe88";